import type { FlightData } from '../types/activity.types';
import type { FlightItem } from '../types/flight.types';

function buildFlightNotes(flight: FlightItem): string | undefined {
  const parts: string[] = [];

  if (flight.depart_duration?.trim()) {
    parts.push(`Duration: ${flight.depart_duration.trim()}`);
  }

  const stopCount = flight.depart_stop_number;
  if (typeof stopCount === 'number') {
    const stopsLabel =
      stopCount === 0 ? 'Nonstop' : stopCount === 1 ? '1 stop' : `${stopCount} stops`;
    const via = flight.depart_stops_airports?.trim();
    parts.push(via ? `${stopsLabel} (${via})` : stopsLabel);
  }

  return parts.length > 0 ? parts.join('. ') : undefined;
}

export function buildFlightTripStopPayload(flight: FlightItem): FlightData {
  const payload: FlightData = {
    amount_spend: flight.price,
    flight_from: flight.depart_departure_airport,
    flight_to: flight.depart_arrival_airport,
    flight_from_airport_name: flight.depart_departure_airport_name,
    flight_to_airport_name: flight.depart_arrival_airport_name,
    departure_date_time: flight.depart_departure_date_time,
    arrival_date_time: flight.depart_arrival_date_time,
    airline: flight.depart_airline_name,
    airline_iata_code: flight.depart_airline,
    flight_number: flight.depart_flight_number,
  };

  const notes = buildFlightNotes(flight);
  if (notes) {
    payload.notes = notes;
  }

  return payload;
}
